import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler } from '@angular/core';
import { HttpModule, JsonpModule } from '@angular/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { ToasterModule } from 'angular2-toaster';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';


// root component
import {AppComponent} from './app-root.component';
// feature modules
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { LoginModule } from './login/login.module';
import { AuthInterceptor } from './core/services/interceptor';
// import { NewVisitModule } from './new-visit/new-visit.module';
// routing
import {AppRoutingModule} from './routing.module';

// logout component
import { LogoutComponent } from './logout/logout.component';

// logout component
import { WelcomeComponent } from './welcome/welcome.component';

// cancelled visit component
import { CancelledComponent } from './app-vms/cancelled/cancelled.component';

// front end error handler
import { GlobalErrorHandler } from './core/services/frontend-error.handler';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    AppRoutingModule,
    JsonpModule,
    SharedModule,
    CoreModule,
    LoginModule,
    HttpClientModule,
    ToasterModule.forRoot(),
    LoadingBarHttpClientModule
    // NewVisitModule,
  ],
  declarations: [
    AppComponent,
    LogoutComponent,
    WelcomeComponent,
    CancelledComponent
  ],

  // this schema is here so that we can use web components
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    // interceptor (this is for auth and global backend error handler)
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // frontend global error handler
     {
       provide: ErrorHandler,
       useClass: GlobalErrorHandler
     }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
